import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import OptimizeBy from "components/Project/OptimizeBy";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

class OptimizeByContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <OptimizeBy {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const projectId = ownProps.id;

  return {
    updateProjectOptimizeBy: (runId, optimizeBy) =>
      dispatch(projectReducer.updateProjectOptimizeBy(projectId, runId, optimizeBy)),
    updateProjectOptimizeGoal: (runId, optimizeGoal) =>
      dispatch(projectReducer.updateProjectOptimizeGoal(projectId, runId, optimizeGoal)),
    updateProjectOptimizeByCount: (runId, optimizeByCount) =>
      dispatch(projectReducer.updateProjectOptimizeByCount(projectId, runId, optimizeByCount)),
    deleteOptimizeBy: (runId) => {
      dispatch(projectReducer.updateProjectOptimizeBy(projectId, runId, undefined));
      dispatch(projectReducer.updateProjectOptimizeGoal(projectId, runId, undefined));
      dispatch(projectReducer.updateProjectOptimizeByCount(projectId, runId, undefined));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const projectId = ownProps.id;
  const runId = projectReducer.getInnerId(state, projectId);

  let modelGroups = ownProps.modelGroups;
  if (!modelGroups || Number(modelGroups.id) !== Number(projectId)) {
    modelGroups = projectReducer.getModelGroups(state, projectId);
  }

  return {
    optimizeBy: projectReducer.getProjectOptimizeBy(state, projectId),
    projectSuccess: projectReducer.getProjectDatasetSuccess(state, projectId),
    modelGroups: modelGroups,
    outcome: setupReducer.getOutcomeFromDataset(state, runId),
    success: setupReducer.getSuccessValue(state, runId),
    setupLabels: setupReducer.getSetupLabels(state, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(OptimizeByContainer);
